import { DefaultTheme } from 'styled-components/macro';
import { DSColorsKeys, DSColorValues } from 'styles';

export const getDSColor = (
  theme: DefaultTheme,
  colorKey: DSColorsKeys = 'gray.800'
): DSColorValues => {
  const [palette, shade] = colorKey.split('.') as [
    keyof (typeof theme)['colors'],
    string,
  ];
  const colorGroup = theme.colors[palette];

  return typeof colorGroup === 'string'
    ? colorGroup
    : colorGroup?.[shade as unknown as keyof typeof colorGroup];
};

export const hexToRGB = (hex: string, opacity?: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  // В восьмизначном хексе последние две цифры — прозрачность самого цвета.
  // Если её не учесть, цвет станет непрозрачным.
  // Переданный вторым аргументом opacity важнее.
  const hexAlpha =
    hex.length === 9
      ? Math.round((parseInt(hex.slice(7, 9), 16) / 255) * 1000) / 1000
      : undefined;
  const alpha = opacity ?? hexAlpha;

  if (alpha !== undefined) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
};
